/**
 * created by lei lei
 * 微博预览
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Row, Col, Button} from "antd";
import * as Utils from "../../../utils";
import {Scrollbars} from "react-custom-scrollbars";

export default class MicroBlogReview extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            microBlogStatus: false,
            titlePic: '',
            summary: '',
            content: '',
            updateDate: '',
            author: '',
            picUrls: [],
            publishUrl: null,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {

        return (
            <div>
                <Modal key={Utils.uuid()} title={"内容详情"} visible={this.state.microBlogStatus}

                       onCancel={() => {
                           this.setState({microBlogStatus: false})
                       }} footer={
                    this.state.publishUrl ?
                        <Button type="primary" onClick={() => {
                            window.open(this.state.publishUrl)
                        }}> 查看原微博</Button> : null

                }>
                    <Scrollbars  autoHide autoHeight autoHeightMax={this.state.publishUrl? "72vh":"78vh"} >
                        <div style={{overflow: 'hidden'}}>
                            <div style={{padding: "0"}}>
                                <span>{this.state.updateDate}</span>
                                <div dangerouslySetInnerHTML={{__html: this.state.content}}></div>
                                <div style={{position: 'relative', paddingTop: 10}}>
                                    <Row>
                                        {this.state.picUrls && this.state.picUrls.length && this.state.picUrls.map((item, i) => {
                                            return (
                                                <Col span={6} key={i}>
                                                    <div style={{paddingTop: 8,}}>
                                                        <img style={{width: 110, height: 110,objectFit:'cover'}} src={item} alt=""/>
                                                    </div>
                                                </Col>
                                            )

                                        })}

                                    </Row>
                                </div>

                            </div>
                        </div>
                    </Scrollbars>
                </Modal>
            </div>
        )
    }

    show(record, signWords = []) {
        let content
        if (signWords.length > 0) {
            content = Utils.filtion(signWords, "<div>" + record.content + "</div>").value;
        }else{
            content ="<div>" + record.content + "</div>";

        }
        this.setState({
            microBlogStatus: true,
            ...record,
            content
        })
    }

}